module.exports = __webpack_public_path__ + "static/img/discount-tag.ae540d2c.png";